import _ from 'lodash'
import * as utils from '@/mixins/utils'
import store from '@/store'
import * as constants from '@/store/constants'
import * as types from '@/store/types'
import SimpleVueValidator from 'simple-vue-validator';
import moment from 'moment'

const Validator = SimpleVueValidator.Validator;

const tempMixin = {
    validators: {
      purposeId: function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value) || value === 0) {
              return 'This is a required field.'
          }  
        })
      },      
      'purposeOthers, purposeId': function (purposeOthers, purposeId) {
        return Validator.custom(function () {
          if ( store.state.modified && purposeId === constants.PURPOSE_OTHERS && Validator.isEmpty(purposeOthers) ) {
              return 'This is a required field.'
          }
        })
      },
      venues: function (value) {
        return Validator.custom(function () {
          if (value.length === 0) {
              return 'Venue is a required field.'
          }

          for (let item of value) {
            if ( Validator.isEmpty(item.date_from) && Validator.isEmpty(item.date_to)) {
                 return 'Date From and Date To is a required field.'        
            }
            else if ( Validator.isEmpty(item.date_from) ) {
                 return 'Date From is a required field.'        
            }
            else if ( Validator.isEmpty(item.date_to)) {
                 return 'Date To is a required field.'        
            }
            else if ( Validator.isEmpty(item.venue_name)) {
                 return 'Venue Name is a required field.'        
            }
          }          
        })
      },
      'venue.city': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },      
      'venue.venue_name': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },      
      // 'venue.gps':  function (value) {
      //   console.log(value + " = "+ utils.isValidGPSDecimal(value))
      //   return Validator.custom(function () {
      //     if (Validator.isEmpty(value)) {
      //         return 'This is a required field.'
      //     }
      //     else if ( utils.isValidGPSDecimal(value) ) {
      //          return 'Invalid GPS coordinates.' 
      //     }  
      //   })
      // },      
      'venue.gps': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },      
      'venue.date_from':  function (value) {
        let temp = moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DDTHH:mm:ss')
        let dDateFrom = moment(temp)

        let startTime = moment(this.$store.state.start_date).format('HH:mm:ss')
        let format = 'YYYY-MM-DDT'+ startTime +'Z'

        temp = moment(this.$store.state.start_date).format( format )
        let dStartDate = moment(temp)

        temp = moment(dDateFrom).format('YYYY-MM-DDT18:00:00')
        let dCutoffDate = moment(temp, 'YYYY-MM-DDTHH:mm:ss')

        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }
          // else if (dDateFrom.isBefore(dStartDate) || dDateFrom.isAfter(dCutoffDate)) {  
          //     return 'Time of the movement should be only allowed between '+  dStartDate.hour()+':00 and 18:00'
          // }
        })
      },      
      'venue.date_to':  function (value) {
        let temp = moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DDTHH:mm:ss')
        let dDateTo = moment(temp)

        let startTime = moment(this.$store.state.start_date).format('HH:mm:ss')
        let format = 'YYYY-MM-DDT'+ startTime +'Z'

        temp = moment(this.$store.state.start_date).format( format )
        let dStartDate = moment(temp)

        temp = moment(dDateTo).format('YYYY-MM-DDT18:00:00')
        let dCutoffDate = moment(temp, 'YYYY-MM-DDTHH:mm:ss')

        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
          // else if (dDateTo.isBefore(dStartDate) || dDateTo.isAfter(dCutoffDate)) { 
          //     return 'Time of the movement should be only allowed between '+  dStartDate.hour()+':00 and 18:00'
          // }
        })
      }
    } //-- validators
  }

export default tempMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/Temp-validators.js